module.exports = __webpack_public_path__ + "img/stop-4.73a2779f.jpg";